module.exports = __webpack_public_path__ + "static/media/grabaseat3.9fe676cb.jpg";